// Author Liang Gang Qiang
// Date 2021-11-04 10:39:39

import * as model from "@/model/mintalMes/prd/MintalMesPrdProductionEquipQuotaModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";
import {customVuexEntityPatternFactory} from "@/store/em/commonPattern/customVuexEntityPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdProductionEquipQuota(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'pelletizingFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'smeltingFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'pelletizingEntity',
        entityConstructor: model.MintalMesPrdProductionEquipQuota
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'smeltingEntity',
        entityConstructor: model.MintalMesPrdProductionEquipQuota
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'pelletizingVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'smeltingVo'
    })
    .buildStore()
